import { useMissionsTranslation } from '../../../../ui/hooks';
export const useFormDenyConfig = () => {
    const { t } = useMissionsTranslation();
    return {
        type: 'form',
        children: [
            {
                type: 'form.content',
                html: `<p class="body1">${t('shifts.pendingRequest.denyShift.description')}</p>`,
            },
            {
                type: 'form.advancedRadio',
                key: 'denialReason',
                values: [
                    {
                        value: 'deniedNotQualified',
                        label: t('shifts.pendingRequest.denyShift.notQualified'),
                        description: t('shifts.pendingRequest.denyShift.notQualifiedDescription'),
                    },
                    {
                        value: 'deniedRosterFull',
                        label: t('shifts.pendingRequest.denyShift.fullRoster'),
                        description: t('shifts.pendingRequest.denyShift.fullRosterDescription'),
                    },
                ],
                validate: {
                    required: true,
                },
            },
        ],
    };
};
